import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import FormCad from '../../../../components/auth/renunciareceita/form_cad'


function CadastrarRenunciaReceitaScreen() {

    return (
        <Fragment>
            <Head titulo="Cadastrar Renúnica de Receita" />
            <HeaderLogged />
            <Container>
               <FormCad />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default CadastrarRenunciaReceitaScreen;